module.exports = __webpack_public_path__ + "static/img/organilog-01.a933d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/organilog-01.png
// module id = 118
// module chunks = 0